import ActivityCategorymasterInput from "../../../components/ActivityMasterInput/ActivityCategorymasterInput";
import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";
import HeaderBread from "../../../components/HeaderBread";
import Layout from "../../../Layout";

const CreateActivityMaster = () => {
  const navigation = [
    {
      title: "Home",
      route: "/",
    },
    {
      title: "Categories",
      route: "/shore/mobile-masters/activity-categories",
    },
    {
      title: "Add Categories",
      route: "/shore/mobile-masters/activity-categories/add",
    },
  ];

  return (
    <Layout type={"create_per"} module_data={"Categories"}>
      <CustomHeaderTitle title={"Create Categories"} />
      <HeaderBread
        navigation={navigation}
        title={"Add Categories"}
      ></HeaderBread>
      <ActivityCategorymasterInput crisisdata={{}} />
    </Layout>
  );
};

export default CreateActivityMaster;
